import { fade } from "@material-ui/core/styles/colorManipulator";

export const styles = theme => ({
  chartContainer: {
    marginLeft: -22
  },
  tableContainer: {
    height: 320
  },
  showDialog: {
    display: "block"
  },
  hiddenDialog: {
    display: "none"
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade("#9E9E9E", 0.15),
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.8)"
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto"
    },
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex"
    // backgroundColor: '#eaeaea'
  },
  inputRoot: {
    color: "inherit",
    width: "100%"
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200
      }
    }
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between"
  },
  icon: {
    fontSize: 40,
    float: "right",
    cursor: "pointer"
  },
  iconWrap: {
    fontSize: 40,
    float: "right",
    cursor: "pointer",
    padding: "4px"
  },
  btnGroupContainer: {
    boxShadow: `0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)`
  },
  btnRoot: {
    color: "#263238",
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "16px",
    paddingRight: "16px",
    fontSize: "14px",
    minWidth: "64px",
    // transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    // font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    fontWeight: 500,
    lineHeight: 1.75,
    borderRadius: "4px",
    // border-top-right-radius: 4px;
    // border-bottom-right-radius: 4px;
    // letter-spacing: 0.02857em;
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 0.87)",
    backgroundColor: "#ffffff"
  },
  calendarIcon: {
    marginRight: theme.spacing(1)
  },
  textField: {
    display: "none"
  },
  dateTimePicker: {
    right: 0
  }
});
